<script lang="ts">
	import { DeviceBrowser, DeviceGroup, GroupConflictError } from "luxedo-data"
	import { ProjectorMenuController } from "../ProjectorMenuController.svelte"
	import { launchLuxLink } from "../LuxLinkLauncher"
	import { Toast } from "toaster"
	import { CollapsibleSectionNoBind, ToggleArrow } from "misc-ui"
	import SelectedDevicePreview from "./SelectedDevice_Preview.svelte"
	import DeviceSelectorSidebar from "../device-selector/DeviceSelectorSidebar.svelte"
	import { reactivateGroup } from "../GroupReactivator"
	import { Responsive } from "responsive"

	let device = $derived(ProjectorMenuController.ctx.device)
	let isMobile = $derived(Responsive.isMobile)

	let expanded = $state(false)

	// #region Actions

	/**
	 * Reactivates the selected group by deactivating active conflicting groups
	 */
	async function onReactivateGroup() {
		if (!(device instanceof DeviceGroup)) return

		reactivateGroup(device)

		Toast.success(`Group ${device.isDeactivated ? "deactivated" : "activated"} successfully!`)
	}

	// #endregion

	$effect(() => {
		if (device) expanded = false
	})
</script>

<div id="device-preview" class:isMobile>
	{#if isMobile}
		<CollapsibleSectionNoBind {expanded} onclick={() => (expanded = !expanded)}>
			{#snippet header()}
				<div class="mobile-header">
					<SelectedDevicePreview {device} />
					<ToggleArrow isFlipped={expanded} />
				</div>
			{/snippet}
			{#snippet content()}
				<div class="expanded-selector">
					<DeviceSelectorSidebar />
				</div>
			{/snippet}
		</CollapsibleSectionNoBind>
	{:else}
		<SelectedDevicePreview {device} />
	{/if}
	{#if !isMobile}
		<!-- if user is mobile, they must run these from the controls panel -->
		<div class="device-action-container">
			{#if device instanceof DeviceGroup && device.isDeactivated}
				<button id="group-reactivate" class="outline-button" onclick={onReactivateGroup}>
					Reactivate
				</button>
			{:else if device instanceof DeviceBrowser && !DeviceBrowser.ONLINE_STATUSES.includes(device._status)}
				<button id="LuxLink-launcher" class="outline-button" onclick={() => launchLuxLink(device)}
					>Start LuxLink</button
				>
			{/if}
		</div>
	{/if}
</div>

<style>
	#device-preview {
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}

	#device-preview.isMobile {
		flex-direction: column;
	}
	.device-action-container {
		display: flex;
		align-items: center;
	}

	.isMobile .device-action-container:has(button) {
		margin-top: 1rem;
	}

	button {
		font-size: var(--h1);
		margin-left: 1rem;
		text-wrap: nowrap;
	}

	.mobile-header {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		padding-right: 0.5rem;
	}

	.expanded-selector {
		padding-top: 2rem;
		max-height: 50vh;
		overflow-y: scroll;
	}

	.isMobile button {
		font-size: var(--h2);
		padding: 0.1rem 1rem;
	}
</style>
